import React from 'react'
import logoFull3 from '@images/logo_full3.png'

const Header = () => {
  return (
    <div className="header">
      <div className="header__background">
        <img className="header__logo" src={logoFull3} alt="eFishery Engineering" />
      </div>
    </div>
  )
}

export default Header
